import React, { useEffect } from 'react';
import { getBomQuestionPreviewFactory, getStockImageUrlForBom } from '../../../main/selectors';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { getScene7StockImageModeAsync } from '../../../main/logics';
import { isMobileOnly } from 'react-device-detect';
import styles from './Scene7ImageIcon.scss';

const Scene7ImageIcon = ({ active = false, option, questionId }) => {
  const dispatch = useDispatch();

  const previewUrl = useSelector(getBomQuestionPreviewFactory(questionId, option));
  const stockImageUrl = useSelector((state) => getStockImageUrlForBom(state, option));
  const url = !!previewUrl ? previewUrl : stockImageUrl;

  useEffect(() => {
    if (!previewUrl) {
      dispatch(getScene7StockImageModeAsync(option));
    }
  }, [dispatch, option, previewUrl]);

  let rootCssClass = styles['scene7-image-icon'];
  rootCssClass += isMobileOnly ? ` ${styles['mobile']}` : ` ${styles['desktop']}`;
  if (active) rootCssClass += ` ${styles['active']}`;

  return (
    <div className={rootCssClass}>
      <img alt="" aria-hidden="true" src={url} />
    </div>
  );
};

Scene7ImageIcon.propTypes = {
  active: PropTypes.bool,
  option: PropTypes.shape({
    code: PropTypes.string.isRequired,
    codeValue: PropTypes.string.isRequired,
    colorGroupList: PropTypes.arrayOf(PropTypes.string).isRequired,
    colorReference: PropTypes.string.isRequired,
    componentId: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    futureShipDateSettingStatus: PropTypes.oneOf([0, 1, 2]).isRequired,
    helpLink: PropTypes.shape({
      helpText: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }),
    inventoryMessage: PropTypes.string.isRequired,
    isFutureShipDateSettable: PropTypes.bool.isRequired,
    isOutOfStock: PropTypes.bool.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isSoldOut: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    optionText: PropTypes.string.isRequired,
    outOfStockMessage: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    sequence: PropTypes.number.isRequired,
    useTexture: PropTypes.bool.isRequired,
    yearOptionPricing: PropTypes.oneOf([0, 1, 2]).isRequired,
  }).isRequired,
  questionId: PropTypes.number.isRequired,
};

export default Scene7ImageIcon;
